import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=7b7349fa"
import script from "./PageBase.vue?vue&type=script&lang=js"
export * from "./PageBase.vue?vue&type=script&lang=js"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=7b7349fa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports